"use client";

import React, { ReactNode, useCallback, useEffect, useState } from "react";
// import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
// import GradientButton from "@/components/ui/gradient-button";
import { useLoading } from "@/contexts/LoadingContext";
// import ReactPhoneInput from "react-phone-number-input";
import PhoneInput from "../.././questionnaire/ui/input-types/PhoneInput";
import axiosInstance from "@/api/axios";
import toastService from "@/services/toastService";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
  //   countryCode: string;
}

const initialFormState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  companyName: "",
  // countryCode: "",
};


const ScheduleDemo: React.FC<{children: ReactNode,forceOpenOnClick?: boolean}> = ({children,forceOpenOnClick = false}) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<FormData>(initialFormState);
  const [country,setCountry] = useState<string | undefined>(undefined);
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  const { setLoading } = useLoading();
  const navigate = useNavigate();
  // const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const submitDemoDetails = useCallback(
    async (formData: FormData) => {
      setLoading(true);
      try {
        console.log(formData, "line 36");
        const response = await scheduleDemo(formData);
        if (response.statusCode === 200) {
          toastService.success("Request Confirmed");
          setFormData(initialFormState);
        }
      } catch (err) {
        console.error("Error while scheduling demo:", err);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const handleTriggerClick = (e: React.MouseEvent) => {
    if ((user !== null )&&(!forceOpenOnClick)) {
      e.preventDefault();
      // console.log("hello i amm user", user);
      navigate("/dashboard/explore_leads");
    } else {
      setOpen(true);
    }
  };

  const scheduleDemo = async (formData: FormData) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/user/api/v1/demo/schedule",
        data: formData,
      });
      console.log("Schedule Demo Response", response);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log(formData, "line 34");
    if (!isPhoneValid || !formData.phone) {
      toastService.error("Please enter a valid phone number.");
      return;
    }
    submitDemoDetails(formData);

    setOpen(false);
  };
  
  // useEffect(() => {
  //   // Replace this logic with your actual auth logic
  //   const user = localStorage.getItem("accessToken"); // check for token
  //   setIsLoggedIn(!!user);
  // }, []);
  useEffect(() => {
    const userDataString = localStorage.getItem("user"); // Adjust the key if needed
    if (!userDataString) return;
  
    try {
      const userData = JSON.parse(userDataString);
  
      let firstName = "";
      let lastName = "";
      if (userData.fullName) {
        const nameParts = userData.fullName.split(" ");
        firstName = nameParts[0] || "";
        lastName = nameParts.slice(1).join(" ") || "";
      }
      const email = userData.email || "";
      let phone = userData.phoneNumber || "";
      let companyName = userData.companyName || "";
  
      if (userData.answers && Array.isArray(userData.answers)) {
        for (const answerObj of userData.answers) {
          const key = answerObj?.questionDetails?.key;
          const answer = answerObj?.answer;
  
          if (key === "phoneNumber" && !phone) phone = answer;
          if (key === "companyName" && !companyName) companyName = answer;
          if (key === "fullName" && (!firstName || !lastName)) {
            const parts = (answer || "").split(" ");
            firstName = parts[0] || "";
            lastName = parts.slice(1).join(" ") || "";
          }
        }
      }
  
      console.log("User data set from localStorage:", userData.countryName);
      setFormData({
        firstName,
        lastName,
        email,
        phone,
        companyName,
      });
      setCountry(userData.countryName);
      

    } catch (err) {
      console.error("Could not parse user from localStorage:", err);
    }
  }, []);

  return (
    <div className="flex justify-start sm:justify-center">
      <Dialog open={open} onOpenChange={setOpen} >

        <DialogTrigger asChild>
        <div onClick={handleTriggerClick}>{children}</div>
        </DialogTrigger>
        <DialogContent className="w-[80%] mx-auto sm:mx-0 sm:max-w-md p-0 gap-0 rounded-lg">
          <DialogHeader className="  bg-[#f4f4f4] p-4 pb-2 flex flex-row items-center justify-between border-b rounded-t-lg">
            <DialogTitle className="text-xl font-medium">
              Request Access
            </DialogTitle>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 rounded-full"
              onClick={() => setOpen(false)}
            >
              <span className="sr-only">Close</span>
            </Button>
          </DialogHeader>

          <form onSubmit={handleSubmit} className="p-4 space-y-4">
            <p className="text-sm text-gray-500 mb-2">
              Please enter your details to get in touch with us
            </p>

            {/* First Name */}
            <Input
              name="firstName"
              type="text"
              placeholder="First Name"
              required
              value={formData.firstName}
              onChange={handleChange}
              className="rounded-md"
            />

            {/* Last Name */}
            <Input
              name="lastName"
              type="text"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              className="rounded-md"
            />

            {/* Email */}
            <Input
              name="email"
              type="email"
              placeholder="Enter Email"
              required
              value={formData.email}
              onChange={handleChange}
              className="rounded-md"
            />

            {/* Custom Phone Input */}
            <PhoneInput
            value={formData.phone}
            country={country}
              onSubmit={(ans: string | string[]) => {
                const phone = Array.isArray(ans) ? ans[0] : ans;
                setFormData((prev) => ({ ...prev, phone }));
              }}
              onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
              placeholder="Enter Phone"
            />
            {/* <PhoneInput
  onSubmit={(ans: string | string[]) => {
    const fullPhone = Array.isArray(ans) ? ans[0] : ans;

    const phoneMatch = fullPhone?.match(/^(\+\d{1,4})(\d{6,15})$/);

    if (phoneMatch) {
      const [, countryCode, phone] = phoneMatch;
      setFormData((prev) => ({
        ...prev,
        countryCode,
        phone,
      }));
    } else {
      // fallback
      setFormData((prev) => ({
        ...prev,
        countryCode: "",
        phone: fullPhone,
      }));
    }
  }}
  placeholder="Enter Phone"
/> */}

            {/* Company Name */}
            <Input
              name="companyName"
              type="text"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
              className="rounded-md"
            />

            <div className="flex justify-end space-x-2 pt-2">
              <Button
                type="button"
                onClick={() => setOpen(false)}
                className="w-[84px] h-[40px] flex-grow-0 mr-4 px-[20px] py-[11px] rounded-[8px] border border-[#e9e9e9] bg-white text-black hover:bg-gray-100"
              >
                Cancel
              </Button>

              <Button
                type="submit"
                className="w-[100px] h-[40px] flex-grow-0 ml-4 px-[28px] py-[11px] rounded-[8px] bg-[#181818] text-white hover:bg-gray-800"
              >
                Submit
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ScheduleDemo;
